import strings from 'strings/strings.json';
import { useParams } from 'react-router-dom';
import useGetRequest from 'hooks/useGetRequest';
import { PublishedCourse } from 'models/Course';
import PublishedCourseView from 'components/courseSchedule/PublishedCourseView';
import NavBackButton from 'components/buttons/NavBackButton';
import Header from 'components/sections/Header';
import React from 'react';
import { AuthContext } from 'contextProviders/AuthContext';
import { RoleType } from 'models/User';

export default function ViewPublishedCoursePage(): JSX.Element {
    const params = useParams();
    const { courseId } = params;
    const { userData } = React.useContext(AuthContext);

    const { data: course, loading } = useGetRequest<PublishedCourse>(`courses/${courseId}`, !courseId);

    if (loading || !course) return <></>;

    return (
        <>
            <Header
                title={course.title}
                logoS3Filepath={course.organisation.logoS3Filepath}
                aboveTitleElement={
                    userData.activeRole === RoleType.ORGANISATION_ADMIN ? (
                        <NavBackButton
                            backButtonTitle={strings.OACoursePage.backToDashboardButton.title}
                            backButtonAria={strings.OACoursePage.backToDashboardButton.aria}
                            backButtonHref="/organisation/dashboard"
                            backButtonNavigateState={{ state: { activeTabId: 'courses' } }}
                        />
                    ) : (
                        <NavBackButton
                            backButtonTitle={strings.OACoursePage.backToDashboardButton.title}
                            backButtonAria={strings.OACoursePage.backToDashboardButton.aria}
                            backButtonHref="/trainer/dashboard"
                            backButtonNavigateState={{ state: { activeTabId: 'scheduleCourses' } }}
                        />
                    )
                }
            />
            <PublishedCourseView course={course} />
        </>
    );
}
